// Local presentation values that are specific to a host and absent from ThemeV2.
// Survey colors, typography, spacing, and control shape still come from ThemeV2.
export const hostThemes = {
  chat: {
    shell: {
      maxWidth: 700,
      desktopInset: 20,
      cornerRadius: 20,
    },
    header: {
      verticalInset: 10,
      horizontalInset: 20,
      titleInset: 15,
      avatarSize: 35,
      clientLogoMaxWidth: 100,
      clientLogoMaxHeight: 30,
    },
    bubble: {
      cornerRadius: 16,
      incomingMaxWidth: "92%",
      maxMediaWidth: 600,
      tailSize: 24,
      tailBottomOffset: 12,
    },
    composer: {
      height: 72,
      placeholderPaddingDesktop: 3,
      placeholderPaddingMobile: 6,
      placeholderPaddingLeft: 10,
    },
    overlay: { dialogMaxWidth: 600, mediaMaxWidth: 960 },
  },
  forms: {
    canvas: {
      compactInset: 15,
      wideInset: 50,
      clientLogoMaxWidth: 120,
      clientLogoMaxHeight: 58,
    },
    questionPanel: { wideMinHeight: "70vh" },
    controls: { wideSendBottom: "10%", wideSendRight: "8%" },
    questionImage: { maxHeight: 600, expandedMinHeight: 180 },
    overlay: { dialogMaxWidth: 600, mediaMaxWidth: 960 },
  },
} as const;
